import React from 'react';
import { QuoteIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const testimonials = [{
  quote: 'I sent her my list on Monday afternoon and by Tuesday morning everything was at my door. She even called me when Titus fish price changed instead of just buying it. That honesty won me.',
  name: 'Chidinma',
  area: 'Gbagada'
}, {
  quote: 'As a busy nursing mum, Mile 12 stress is not something I can do right now. Swift Errands has been doing my monthly foodstuff run for 3 months and I have no complaints. Everything fresh.',
  name: 'Mrs. Adeyemi',
  area: 'Magodo'
}, {
  quote: 'I was skeptical about paying upfront at first, but she confirmed every price with me before I transferred. Now my whole office uses her for market runs.',
  name: 'Tunde',
  area: 'Yaba'
}];
export function Testimonials() {
  return <section id="testimonials" className="w-full bg-lavender-light py-14 sm:py-20" data-id="element-193" data-mp="v85alzo35h3u">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-194" data-mp="qbesl6sq0bfs">
        <Reveal className="text-center md:text-left" data-id="element-195" data-mp="q8irj9lkt6n4">
          <h2 className="font-display text-3xl uppercase tracking-tight text-purple sm:text-4xl" data-id="element-196" data-mp="h55a40zwdtwk">What Customers Say</h2>
          <p className="mt-2 text-ink/60" data-id="element-197" data-mp="m6chw021it38">Real Lagos customers, real market runs.</p>
        </Reveal>

        <div className="mt-8 grid gap-4 md:grid-cols-3" data-id="element-198" data-mp="79lhpokjldck">
          {testimonials.map((item, index) => <Reveal key={item.name} delay={index * 0.12} className="rounded-card border border-lavender bg-white p-6 text-center shadow-soft transition duration-300 hover:-translate-y-1.5 hover:shadow-lift md:text-left" data-id="element-199" data-mp="c73rtiaapym5" data-mpi={index}>
              <QuoteIcon className="mx-auto h-6 w-6 text-gold md:mx-0" aria-hidden="true" data-id="element-200" data-mp="14xdcyd01i4hi" />
              <blockquote className="mt-3 text-sm leading-relaxed text-ink/75" data-id="element-201" data-mp="q4jvim17jea7">&ldquo;{item.quote}&rdquo;</blockquote>
              <p className="mt-4 text-sm font-bold text-purple" data-id="element-202" data-mp="1iva9j9ehuaw6">
                {item.name}, <span className="font-medium text-ink/60" data-id="element-203" data-mp="1it7fmea7zxm6">{item.area}</span>
              </p>
            </Reveal>)}
        </div>
      </div>
    </section>;
}